import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tablet-screenshots" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "card mb-2" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = { class: "input-group mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "Start", -1)
const _hoisted_10 = { class: "col-3" }
const _hoisted_11 = { class: "input-group mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "End", -1)
const _hoisted_13 = { class: "col-sm-6 col-md-4 col-lg-3" }
const _hoisted_14 = { class: "card mt-3 mb-3" }
const _hoisted_15 = { class: "card-body snapshot-trigger" }
const _hoisted_16 = {
  key: 0,
  class: "spinner-border",
  role: "status"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-camera-fill" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" New Snapshot ")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]

import { onBeforeMount, reactive, ref, computed, onUnmounted } from "vue";
import { tabletPageModule } from "@/store/modules/tablet-page.module";
import Datepicker from "@vuepic/vue-datepicker";
import ScreenshotsGrid from "@/components/screenshots-grid.component.vue";
import { tabletsModule } from "@/store/modules/tablets.module";
import { Unsubscribe } from "firebase/firestore";
import tabletScreenshotsService from "@/services/da/tablet-screenshots.service";
import "@vuepic/vue-datepicker/dist/main.css";


export default /*#__PURE__*/_defineComponent({
  name: 'tablet-screenshots-page',
  setup(__props) {

const startTime = ref(new Date);
const endTime = ref();

const snapshotWaiting = false;

const takeSnapshot = function() 
{
  tabletPageModule.preloadLatestScreenshots(1)
  tabletsModule.takeSnapshotCommand(tabletPageModule.data.Id)
}

const load = async () => {

  await tabletPageModule.loadScreenshots({
    size: 100,
    beforeTheTime: startTime.value.getTime(),
    afterTheTime: (endTime.value as any instanceof Date) ? endTime.value.getTime() : 0,
    lastSeen: null,
  });
}
onBeforeMount(load);

const screenshots = computed(() =>
  tabletPageModule.screenshots.map((screenshot) => {
    const { FileUrl, MDate, createdAt } = screenshot;
    return {
      thumbnail: FileUrl,
      source: FileUrl,
      title: MDate,
      id: createdAt,
    };
  })
);

const loading = computed(() => tabletPageModule.locked);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_unref(Datepicker), {
                    modelValue: startTime.value,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((startTime).value = $event)),
                      load
                    ]
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_unref(Datepicker), {
                    modelValue: endTime.value,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((endTime).value = $event)),
                      load
                    ],
                    preventMinMaxNavigation: "",
                    maxDate: startTime.value,
                    maxTime: {hours: startTime.value.getHours(), minutes: startTime.value.getMinutes()}
                  }, null, 8, ["modelValue", "maxDate", "maxTime"])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(ScreenshotsGrid, { images: _unref(screenshots) }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (_unref(loading))
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-light",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (takeSnapshot()))
                  }, _hoisted_21))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["images"])
  ]))
}
}

})